// extracted by mini-css-extract-plugin
export var layoutContainer = "_3q-0";
export var layoutContainerOpen = "_3q-5";
export var layoutContainerResizing = "_3q-1";
export var mainContent = "_3q-2";
export var resizeDivider = "_3q-3";
export var slidePanel = "_3q-4";